document.addEventListener('DOMContentLoaded', function() {
    document.querySelector('.variant-picker__option-values').classList.add('disabled');
    document.querySelector('product-form .add-to-cart-button').classList.add('disabled');
    wdsSetSubscribe();
    document.addEventListener('variant:change', function(event) {
        document.querySelector('product-form .add-to-cart-button').classList.add('disabled');
        document.querySelector('.variant-picker__option-values').classList.add('disabled');
        wdsSetSubscribe();
    });
});
async function wdsGetCart() {
    const result = await fetch('/cart.js');
    return await result.json();
}
async function wdsSetSubscribe() {
    const cart = await wdsGetCart();
    const atcBtn = document.querySelector('product-form .add-to-cart-button');
    const variantPicker = document.querySelector('.variant-picker__option-values');
    
    let subQty = 0;
    const id = document.querySelector('input[name="id"]').value;
    cart.items.forEach(item => {
        if (item.id !== Number.parseInt(id) && item.selling_plan_allocation) {
            subQty++;
        }
    });
    if (subQty > 1) {
        subQty = 2;
    }
    
    const observer = new MutationObserver(() => {
        let select = getSubscribtionSelect();
        if (select) {
            select.selectedIndex = subQty;
            select.dispatchEvent(new Event('change', { bubbles: true }));
            observer.disconnect();
        }
        changeRechargeElements(subQty);
        atcBtn.classList.remove('disabled');
        if (variantPicker) variantPicker.classList.remove('disabled');
    });
    observer.observe(document.body, { childList: true, subtree: true });
}
function getSubscribtionSelect() {
    const widget = document.querySelector('recharge-subscription-widget');
    if (!widget) return;
    const root1 = widget.shadowRoot;
    if (!root1) return;
    const sellingPlans = root1.querySelector('rc-selling-plans');
    if (!sellingPlans) return;
    const root2 = sellingPlans.shadowRoot;
    if (!root2) return;
    const select = root2.querySelector('select[name="rc_plan"]');
    return select;
}
function changeRechargeElements(subQty) {
    const widget = document.querySelector('recharge-subscription-widget');
    if (!widget) return;
    const root = widget.shadowRoot;
    if (!root) return;
    rechargePricePerDay(root, subQty);
}
function rechargePricePerDay(root, subQty) {
    
    const onePriceBlock = root.querySelector('.rc-selection__onetime .rc-purchase-option__prices');
    if (!onePriceBlock) return;
    const onePriceFakeBlock = root.querySelector('.rc-selection__onetime .rc-price.rc-price-fake');
    const priceBlock = root.querySelector('.rc-purchase-option__subscription .rc-purchase-option__prices');
    if (!priceBlock) return;
    const defaultPriceFakeBlock = root.querySelector('.rc-purchase-option__subscription .subscription-original-price');
    const discountPriceFakeBlock = root.querySelector('.rc-purchase-option__subscription .subscription-discount-price');
    const variantId = document.querySelector('.shopify-product-form input[name="id"]').value;
    fetch(`/variants/${variantId}.js`)
    .then(r => r.json())
    .then(variant => {
        const plans = variant.selling_plan_allocations;
        if (!plans) return;
        const origPriceText = '£' + (plans[0].compare_at_price / 3000).toFixed(2) + '/day';
        const discountPriceText = ' £' + (plans[subQty].price / 3000).toFixed(2) + '/day';

        if (onePriceFakeBlock) {
            onePriceFakeBlock.textContent = origPriceText;
        } else {
            const spanOrigPrice = document.createElement('span');
            spanOrigPrice.className = 'rc-price rc-price-fake';
            spanOrigPrice.textContent = origPriceText;
            onePriceBlock.appendChild(spanOrigPrice);
        }
        if (defaultPriceFakeBlock) {
            defaultPriceFakeBlock.textContent = origPriceText;
        } else {
            const spanDefPrice = document.createElement('span');
            spanDefPrice.className = 'subscription-original-price rc-price strike-through text-muted';
            spanDefPrice.textContent = origPriceText;
            priceBlock.appendChild(spanDefPrice);
        }
        if (discountPriceFakeBlock) {
            discountPriceFakeBlock.textContent = discountPriceText;
        } else {
            const spanDiscPrice = document.createElement('span');
            spanDiscPrice.className = 'subscription-discount-price rc-price';
            spanDiscPrice.textContent = discountPriceText;
            priceBlock.appendChild(spanDiscPrice);
        }
    });
}
